import * as React from 'react';
import TopNavigation from '@components/TopNavigation';
import InfoBoxWiredMinds from '@components/InfoBoxWiredMinds';
import AcademyBanner from '@components/Academy/Banner';
import Footer from '@components/Footer';
import { GlobalStateContext } from '@context/context';
import { useContext, useEffect, useState } from 'react';
import './style.scss';

const Layout = ({
  children,
  classes = '',
  navType,
  progressBar,
  LogoComponent,
  topNavClasses = '',
}) => {
  const { showInfoBox } = useContext(GlobalStateContext);
  const [isPlaybooksPage, setIsPlaybooksPage] = useState(false);
  const [isWiredMindsBlog, setIsWiredMindsBlog] = useState(false);
  const [isAcademyPage, setIsAcademyPage] = useState(false);

  // Determine if the current page is a playbooks page
  useEffect(() => {
    const path = window.location.pathname; // Get the current path
    setIsPlaybooksPage(path.startsWith('/resources/playbooks/'));
    setIsAcademyPage(path.startsWith('/resources/academy/'));
    setIsWiredMindsBlog(
      path.startsWith('/blog/dealfront-acquires-wiredminds/') ||
        path.startsWith('/de/blog/dealfront-uebernimmt-wiredminds/')
    );
  }, []);

  return (
    <>
      {showInfoBox && isAcademyPage && <AcademyBanner />}
      {!isWiredMindsBlog && !isAcademyPage && showInfoBox && (
        <InfoBoxWiredMinds />
      )}
      <TopNavigation
        navType={navType}
        progressBar={progressBar}
        LogoComponent={LogoComponent}
        classes={topNavClasses}
      />
      <main className={classes}>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
